import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import tooltip from '@/mixins/components/tooltip';
import shimmerTable from '@/mixins/components/shimmers/table';
import shimmerBar from '@/mixins/components/shimmers/bar';
import AddSite from './add-site';

export default Vue.component('admin-websites', {
  template: require('./template.html'),
  name: 'admin-websites',
  components: {
    AddSite,
    tooltip,
    shimmerTable,
    shimmerBar,
  },
  data() {
    const cols = ['alias', 'tier', 'status', 'updated'];
    const sortMap = _.zipObject(cols, _.fill(Array(cols.length), -1));
    return {
      cols,
      sortMap,
      sortKey: '',
      filterKey: '',
      paginate: ['sitelist'],
      loading: false,
      lastDroplet: null,
    };
  },
  computed: {
    ...mapGetters([
      'websites',
      'account',
      'priceSource',
      'currentUser',
      'identityId',
      'globalLoading',
    ]),
    sites() {
      const sortOn = this.sortKey || this.cols[0];
      const updated = _.chain(this.websites)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                const e = [];
                _.filter(row, () => {
                  _.forEach(this.cols, (c) => {
                    // clean up the values so that the
                    // searchable items are like how
                    // the template is written
                    const col = this.cleanItem(row, c);
                    e.push(col);
                  });
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn];
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn];

          return (a === b ? 0 : a < b ? 1 : -1) * ascDesc; // eslint-disable-line
        })
        .value();
      return updated;
    },
    sitesLoaded() {
      return this.websites;
    },
  },
  methods: {
    async goToDash(site) {
      await this.$store.dispatch('setCurrentSite', site);
      this.$router.push({ path: `/edit-site/${site._id}` });
    },
    async goToEditor(site) {
      await this.$store.dispatch('setCurrentSite', site);
      this.$router.push({ path: `/edit-page/${site._id}` });
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    cleanItem(item, col) {
      let i = item[col] || '--';
      if (col === 'status' && item.lifecycle === 'design') {
        i = 'unpublished';
      }
      if (col === 'updated' && i !== '--') {
        i = new Date(i);
        i = this._zoneFormat({
          date: i.toISOString(),
          format: 'MM-DD-YYYY hh:mm A z',
        });
      }
      return i;
    },
    highlight(site, query, col) {
      const c = this.cleanItem(site, col);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    setString(type) {
      let t = type;
      if (t.match(/sectionBlock/gi)) {
        t = 'section';
      } else if (t.match(/droplet/gi)) {
        t = 'droplet';
      }
      return t;
    },
    formatErrors(ers) {
      let str = ers.join(' ');
      str = this.seperateCamalCase(str);
      return str;
    },
    startCase(text) {
      return `${_.startCase(text)}: `;
    },
    seperateCamalCase(str) {
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`);
    },
    getHeader(name) {
      let n = name;
      if (n === 'alias') {
        n = 'name';
      }
      if (n === 'tier') {
        n = 'plan';
      }
      return n;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/index.js